import { createIcon } from '@chakra-ui/react';

export const TemperatureCriticalIcon = createIcon({
  displayName: 'TemperatureCriticalIcon',
  viewBox: '0 0 24 24',
  defaultProps: {
    fill: 'none',
    height: '24',
    width: '4',
  },
  path: (
    <>
      <g>
        <path
          d="M12 2.25C13.7949 2.25 15.25 3.70507 15.25 5.5V13.4199C16.1581 14.3143 16.75 15.6682 16.75 17C16.75 19.6234 14.6234 21.75 12 21.75C9.37665 21.75 7.25 19.6234 7.25 17C7.25 15.6551 7.81412 14.3116 8.75 13.4141V5.5C8.75 3.70507 10.2051 2.25 12 2.25ZM12 3.75C11.0335 3.75 10.25 4.5335 10.25 5.5V14.1104L9.96875 14.335C9.24374 14.9162 8.75 15.9488 8.75 17C8.75 18.7949 10.2051 20.25 12 20.25C13.7949 20.25 15.25 18.7949 15.25 17C15.25 15.98 14.7333 14.9174 14.0215 14.3281L13.75 14.1025V5.5C13.75 4.5335 12.9665 3.75 12 3.75ZM12.75 15.1465C13.4828 15.4433 14 16.1608 14 17C14 18.1046 13.1046 19 12 19C10.8954 19 10 18.1046 10 17C10 16.1608 10.5172 15.4433 11.25 15.1465V7.25H12.75V15.1465Z"
          fill="#EF4E4E"
        />
        <path
          d="M23.3334 8.24096L19.3913 0.794593C19.325 0.669391 19.1456 0.66939 19.0793 0.794592L15.1371 8.24082C15.0749 8.35834 15.1601 8.49985 15.2931 8.49986L23.1775 8.49999C23.3105 8.5 23.3957 8.35849 23.3334 8.24096Z"
          stroke="#FFE3E3"
          strokeWidth="4"
        />
        <path
          d="M23.3334 8.24096L19.3913 0.794593C19.325 0.669391 19.1456 0.66939 19.0793 0.794592L15.1371 8.24082C15.0749 8.35834 15.1601 8.49985 15.2931 8.49986L23.1775 8.49999C23.3105 8.5 23.3957 8.35849 23.3334 8.24096Z"
          stroke="#EF4E4E"
          strokeWidth="1.5"
        />
        <path
          d="M18.75 5.9002V3.5002C18.75 3.33451 18.9739 3.2002 19.25 3.2002C19.5261 3.2002 19.75 3.33451 19.75 3.5002V5.9002C19.75 6.06588 19.5261 6.2002 19.25 6.2002C18.9739 6.2002 18.75 6.06588 18.75 5.9002Z"
          fill="#EF4E4E"
        />
        <path
          d="M19.25 7.5C18.9739 7.5 18.75 7.27614 18.75 7C18.75 6.72386 18.9739 6.5 19.25 6.5C19.5261 6.5 19.75 6.72386 19.75 7C19.75 7.27614 19.5261 7.5 19.25 7.5Z"
          fill="#EF4E4E"
        />
      </g>
    </>
  ),
});
